/*!jslint
  this
*/
jQuery(function ($) {
  "use strict";
  $(document).on('click', '.nav-toggle', function () {
    $(this).toggleClass('on');
    $('html').toggleClass('nav-on');
  });

  function appHeight() {
    var wh = $(window).innerHeight();
    document.documentElement.style
      .setProperty('--app-height', wh + 'px');

  }
  window.addEventListener('resize', appHeight)
  appHeight();

  $(function () {
    AOS.init({
      easing: 'ease-in-out-sine',
      duration: 400,
      once: true
    });
  });

  $('.testimonial-carousal').slick({
    dots: true,
    infinite: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      },
    ]
  });
  $('.our-team-carousal').slick({
    dots: true,
    infinite: true,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 4000,
    slidesToShow: 1,
  });
  $('span.spinny-wrapper').slick({
    dots: false,
    infinite: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    vertical: true,
    verticalScrolling: true,
  });
  $('.popup-video').magnificPopup({
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });
  $(document).on('click', '.service-questions-in-tab-head', function (e) {
    $('.service-questions-in-tab').removeClass('tab-open');
    $('.service-questions-in-tab-content').slideUp('normal');
    if ($(this).next().is(':hidden') == true) {
      $(this).parent().addClass('tab-open');
      $(this).next().slideDown('normal');
    }
  });
  $(window).resize(function () { $('span.spinny-wrapper').slick('setPosition'); })
  $(".otpcode input").prop('disabled', true);
  $(document).on('click', '.sendotp', function (e) {
    var $mobile = $(this).data('input');
    var data = { 'mobile': $($mobile).val(), 'ohyesworld-nonce': ajaxdata.nonce };
    $('.sendotp').html('Sending....');
    $('.sendotp').attr('disabled', 'disabled');
    wp.ajax.post('ohyessendotp', data).always(OtpHandler);
  });
  $(document).on('keyup', '.phonenumber input', function (e) {

    var number = $(this).val();
    number = number.match(/\d+/)[0];
    console.log(number.length);
    if (number.length == 10) {
      $('.sendotp').removeAttr('disabled');
    } else {
      $('.sendotp').attr('disabled', 'disabled');
    }
  });

  function OtpHandler(response) {
    if (response.status) {
      $('.sendotp').html('OTP Sent');
      $('.sendotp').attr('disabled', 'disabled');
      setTimeout(function () {
        $('.sendotp').html('Verify');
        $('.sendotp').removeAttr('disabled');
      }, 120000);
      $(".otpcode input").prop('disabled', false);
      $('.sendotp').addClass('disable');

    } else {
      $('.sendotp').removeAttr('disabled');
      alert("Please try again");
    }
  }

  $(document).on('click', '.loadmore', function (e) {
    e.preventDefault();
    var $el = $(this),
      $tgt = $el.data('target'),
      link = $el.attr('href');
    if ($el.attr('disabled'))
      return;
    $el.addClass('loading').attr('disabled', true);
    $el.find('span').html('Loading...')
    $("<div>").load(link + $tgt, function () {
      $($tgt).append($(this).find($tgt).html());
      $el.parents('.load-more').removeAttr('disabled').remove();
    });
  });


  $('.category li:first a').addClass('active');
  $('.post-category').click(function (e) {
    e.preventDefault();
    $('.category a').removeClass('active');
    $(this).addClass('active');
    var $url = $(this).parents('form').attr('action');
    console.log($url);
    var $tgt = '#blog-container';
    var $value = $(this).attr('href');
    $("<div>").load($url + '?type=' + $value + $tgt, function () {
      $($tgt).html($(this).find($tgt).html());
    });
  });
});